export const TAB_IDS = {
  SCHEDULES: "schedules",
  SETTINGS: "settings"
};
